<template>
  <div :class="$style.container">
    <div :class="$style.firstRow">
      <TextBlock
        :title="content.title"
        :content="content.text"/>
        <a v-if="false" :class="$style.downloadLink" :href="content.tech_link_url" target="_blank">
          <svg :class="$style.arrow" ref="icon"><use xlink:href="#arrow"/></svg>
          <span v-html="content.tech_link_text"></span>
        </a>
    </div>
    <div :class="$style.secondRow">
      <!-- <div :class="$style.imgWrapper" v-lazy:background-image="'./static/images/specifications.png'">
        <img v-lazy="'./static/images/specifications.png'" alt="">
      </div> -->

      <ExplodedImage />
    </div>
    <div :class="$style.thirdRow">
      <ul :class="$style.grid">
        <li v-for="spec in content.specifications" :key="spec.title">
          <h4 class="line-title" v-html="spec.title" data-anim="stagger"></h4>
          <span v-for="(text, i) in spec.specs" :key="i" v-html="text" data-anim="fade"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import TextBlock from '@/components/TextBlock'
import ExplodedImage from '@/components/ExplodedImage'

export default {
  props: ['content'],
  components: {
    TextBlock,
    ExplodedImage
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.container {
  background-color: $color-dark-two;
  background-image: url('../assets/pattern.png');
  background-size: 65px;

  @include mq(sm) {
    padding: 250px 50px;
  }
}

.downloadLink {
  position: relative;
  color: $color-blue;
  text-transform: uppercase;
  font-size: font-size(s);
  transition: all 0.3s ease-out;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  margin-top: $standard-margin-mobile;

  .arrow {
    position: relative;
    flex: 0 0 auto;
    width: 30px;
    height: 30px;
    transform: translate(0, -50%);
    z-index: 1;
    transition: all 0.3s ease-out;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 50%;
    margin: auto;
    width: 30px;
    height: 30px;
    border: 1px solid $color-gray-brown;
    border-radius: 50%;
    transition: all 0.3s ease-out;
    margin-left: -15px;
    z-index: 0;
  }

  span {
    margin-top: 15px;
    white-space: nowrap;
  }

  :global(.no-touchevents) &:hover {
    color: white;

    &::after {
      transform: scale(0.8, 0.8);
      background: $color-gray-brown;
    }

    .arrow {
      transform: translate(0, -30%);
    }
  }
}

.firstRow,
.secondRow,
.thirdRow {
  @include grid-size();
  padding: $standard-margin-mobile;

  @include mq(lg) {
    padding: $big-margin;
  }
}

.firstRow {
  display: flex;
  align-items: flex-end;
  flex-flow: column;

  @include mq(sm) {
    flex-flow: row;
  }
}

.secondRow {
  margin: $small-margin-mobile auto;
  padding: 0 20px;

  @include mq(sm) {
    padding: 0 10px;
    margin: $big-margin auto;
  }

  @include mq(md) {
    padding: 0 $big-margin;
  }

  .imgWrapper {
    position: relative;

    &:before {
      content: '';
      position: relative;
      display: block;
      width: 100%;
      padding-top: 46.52%;
    }

    background-size: cover;
  }

  img {
    @include visually-hidden;

    display: block;
    margin: 0 auto;
    // width: 40%;
    width: 100%;
    // mix-blend-mode: lighten;

    @include mq(sm) {
      width: 100%;
      // max-width: 450px
    }
  }
}

.thirdRow {
  margin-top: $standard-margin-mobile;

  @include mq(sm) {
    margin-top: $standard-margin;
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;

  @include mq(sm) {
    grid-auto-columns: 33.33%;
    grid-template-columns: repeat(3, 1fr);
  }

  li {
    margin-top: $small-margin;

    @include mq(sm) {
      margin-top: 20px
    }

    @include mq(lg) {
      margin-top: 25px
    }
  }

  span {
    display: block;
    color: $color-gray-brown;
    padding-right: $big-margin;
    margin: 5px 0;

    @include mq(lg) {
      margin: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TechSpecifications.vue